module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-37.50028620.png";